function onPageLeave(){
  //console.log('onPageLeave')

  function pageLeave(){
    //console.log('pageLeave')

    // stop scroll reveal
    window.preventScrollReveal = true


    // animation
    const tl = gsap.timeline()

    $('html').addClass('js-pagetransi')

    let delayUntilNextPage = 1.4


    if (pageTransiType === 'specific-transition') {
      // specific transition
    } else {
      // regular transition
    }


    // hide old page
    tl.to($('.mainpage'), 1.4, {autoAlpha:0, ease:'power3.inOut'}, 0)


    // pageload bar
    tl.fromTo($('.pageload'), 2, {y:0, x:'-101%'}, {y:0, x:'-20%', ease:'slow (0.1, 0.7, false)'}, 0)


    setTimeout(function(){
      //console.log('stop prevent changing page')
      bus.emit('pageLeaveEnd')
      window.preventPageChanging = false
    }, delayUntilNextPage*1000)
  }
  bus.on('pageLeave', pageLeave)

}
export default onPageLeave